import { render, staticRenderFns } from "./UnitProgramAllocationDetail.vue?vue&type=template&id=23d330a6"
import script from "./UnitProgramAllocationDetail.vue?vue&type=script&lang=js"
export * from "./UnitProgramAllocationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports